module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/weasel.7a358037.png";